export default "__VITE_ASSET__DzVD7gDz__"